<template lang="pug">
section.p-top
  section.container
    .text-center
      .d-flex.justify-content-center.align-items-center.cart-bg
        vue-typed-js(:strings="['在这里下载游戏客户端哟~']", :fadeOut="true")
          h3.text-white.typing.cart-text
    .my-5.row.justify-content-center
      .col-md-6
        .row
          .col-md-4
            img(
              src="http://res.99ro.top/web-assets/img/10.jpg",
              alt="99Ro完整客户端",
              srcset="",
              style="width:150px; height:150px; margin-bottom:16px;"
            )
          .col-md-8.text-left
            label.h4.text-default(style='margin-right:20px;') 99Ro完整客户端
            //- a(href="/#/download", style='font-size:1.5rem;') 
            //-    | 点此下载
            //- br
            //- del
            //-   span(style='font-size:1rem;color:#0056b3;') 暂未开放下载
            h5.text-warning 文件大小: 3.93 GB
            .text-info 
              ul
                li 下载完成后进行解压文件包
                li 运行 [99ro登录器.exe] 即可启动游戏
            //- .text-danger 建议下载完整客户端，避免出现未知異常
            .text-danger 建议通过QQ群下载客户端，速度更快
        .row(style='margin-top:16px;')
          .col-md-6.text-right
            font-awesome-icon.text-ro-light(
                :icon="['fas', 'download']"
              )
            a(href="https://jq.qq.com/?_wv=1027&k=1X1dul2K", target="_blank") 
               | QQ群文件下载
               span.text-ro-light 【极速推荐】
          .col-md-6.text-center
            font-awesome-icon.text-ro-light(
                :icon="['fas', 'download']"
              )
            a(href="https://pan.baidu.com/s/1jbrEZeg0sE1CQps4Qu0pQw?pwd=99ro", target="_blank") 
               | 百度网盘下载
            span.text-ro-light  (提取码: 99ro)
    //- .my-5.row.justify-content-center
    //-   .col-md-6
    //-     .row
    //-       .col-md-4
    //-         img(
    //-           src="http://res.99ro.top/web-assets/img/9.jpg",
    //-           alt="99Ro登錄器補丁",
    //-           srcset="",
    //-           style="width:150px; height:150px; margin-bottom:16px;"
    //-         )
    //-       .col-md-8.text-left
    //-         label.h4.text-default(style='margin-right:20px;') 99Ro登錄器補丁
    //-         //- a(href="/#/download", style='font-size:1.5rem;') 
    //-         //-    | 点此下载
    //-         //- br
    //-         del
    //-           span(style='font-size:1rem;color:#0056b3;') 暂未开放下载
    //-         h5.text-warning 文件大小: 299 MB
    //-         .text-info 
    //-           ul
    //-             li 下载完成后解压到韓服完整客户端进行覆蓋
    //-             li 运行 [99ro登录器.exe] 即可启动游戏
    //-         .text-danger 僅適用於擁有近期完整韓服客户端的玩家
</template>

<script>
/* global $ */
export default {
  data() {
    return {
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.p-top {
  padding-top: 91px;
}
.cart-bg {
  background-image: url(http://res.99ro.top/web-assets/img/background4.jpg);
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 375px;
}
.cart-text {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/DownloadIndex.vue